import { TextFieldProps } from "@mui/material/TextField";

export const defaultTextFieldProps: Pick<TextFieldProps, "fullWidth" | "required" | "variant"> = {
    fullWidth: true,
    required: false,
    variant: "filled",
};
